<template>
  <div class="account-locked d-flex flex-column align-items-center justify-content-center py-5 px-3 text-center">
    <div class="account-locked__card shadow-sm p-4 p-md-5">
      <template v-if="blocksSelfServe">
        <i class="fa-solid fa-user-tie text-primary fs-1 mb-3" aria-hidden="true" />
        <h1 class="h4 mb-2">Подключение обсуждается со специалистом</h1>
        <p class="text-muted mb-4">
          Оставьте заявку — мы поможем настроить систему под вашу компанию и подберём релевантные тендеры без лишнего шума.
        </p>
        <div class="d-flex flex-wrap gap-2 justify-content-center">
          <router-link to="/?funnel=open" class="btn btn-primary">Оставить заявку</router-link>
          <router-link to="/" class="btn btn-outline-secondary">На главную</router-link>
        </div>
      </template>
      <template v-else>
        <i class="fa-solid fa-clock text-warning fs-1 mb-3" aria-hidden="true" />
        <h1 class="h4 mb-2">Пробный период завершён</h1>
        <p class="text-muted mb-4">
          Оформите подписку в личном кабинете, чтобы снова пользоваться поиском закупок,
          списками и анализом. Оплата картой онлайн.
        </p>
        <div class="d-flex flex-wrap gap-2 justify-content-center">
          <button type="button" class="btn btn-primary" @click="$emit('open-cabinet')">
            Открыть личный кабинет
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/store/pinia.js'
import { blocksSelfServeCardBilling } from '@/utils/retailBilling'

defineEmits(['open-cabinet'])

const auth = useAuthStore()
const blocksSelfServe = computed(() => blocksSelfServeCardBilling(auth.user))
</script>

<style scoped>
.account-locked {
  min-height: 50vh;
}
.account-locked__card {
  max-width: 28rem;
  border-radius: 12px;
  background: var(--bs-body-bg, #fff);
}
</style>
